export default "__VITE_ASSET__DaLYY_6b__"